import { Grid } from 'jrgrid';
import React, { Fragment } from 'react';
import { useMutation } from '@apollo/client';
import { Button, Col, FormCheck, Row } from 'react-bootstrap';
import { Loader } from '../../components/Loader';
import Navbar from '../../components/Navbar';
import { pageStockItems, updateNonBarcodeStockMutation } from './api';
import { StockTotals } from './components/StockTotals';
import { stockFilterButtons } from './util';

export const OITStock = (props: any) => {
  const [gridFilter, setGridFilter] = React.useState(null);
  const [refresh, setRefresh] = React.useState(false);
  const [nonBarcodeDeploy, setNonBarcodeDeploy] = React.useState<number[]>([]);
  const [updateNonBarcodeStock] = useMutation(updateNonBarcodeStockMutation);

  const handleCheck = (reqItemNumber: number) => {
    let present = nonBarcodeDeploy.filter((item) => item === reqItemNumber).length > 0;

    if (present) {
      setNonBarcodeDeploy(nonBarcodeDeploy.filter((item) => item !== reqItemNumber));
    } else {
      setNonBarcodeDeploy([...nonBarcodeDeploy, reqItemNumber]);
    }
  };

  const openRequest = ({ value, row }: any) => {
    if (value != null) {
      let link = '/receiving/view/requestId=' + row.requestId;
      return (
        <div>
          <a href={link} className='info'>
            {row._original.requestNumber}
          </a>
        </div>
      );
    } else {
      return '';
    }
  };

  const markDeployed = ({ value, row }: any) => {
    if (value != null) {
      if (row._original.needsBarcode === false && row._original.status !== 'Not Stock') {
        return (
          <div style={{ textAlign: 'center' }}>
            <FormCheck
              checked={nonBarcodeDeploy.filter((item) => item === row._original.requestedItemId).length > 0}
              onChange={() => handleCheck(row._original.requestedItemId)}
            />
          </div>
        );
      }
    }
    return '';
  };

  const handleDeploy = async () => {
    await updateNonBarcodeStock({
      variables: {
        items: nonBarcodeDeploy,
      },
    })
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        alert(`Whoops! ${err}`);
      });
  };

  const stockColumns = [
    {
      column: {
        Header: 'Barcode',
        accessor: 'barcode',
        type: 'string',
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Description 1',
        accessor: 'description1',
        type: 'string',
        resizable: true,
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Description 2',
        accessor: 'description2',
        type: 'string',
        resizable: true,
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Description 3',
        accessor: 'description3',
        type: 'string',
        resizable: true,
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Additional Remarks',
        accessor: 'additionalRemarks ',
        type: 'string',
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Additional Remarks 2',
        accessor: 'additionalRemarks2 ',
        type: 'string',
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Additional Remarks 3',
        accessor: 'additionalRemarks3 ',
        type: 'string',
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Equipment Class',
        accessor: 'majorEquipmentClass',
        type: 'string',
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Request #',
        accessor: 'requestId',
        type: 'number',
        Cell: openRequest,
      },
      type: 'number',
    },
    {
      column: {
        Header: 'Status',
        accessor: 'status',
        type: 'string',
      },
      type: 'string',
    },
    {
      column: {
        Header: () => (
          <div>
            Relocate
            <span style={{ color: '#f00' }}>&nbsp;*</span>
          </div>
        ),
        accessor: 'deployed',
        type: 'boolean',
        width: 75,
        filterable: false,
        Cell: markDeployed,
      },
      type: 'boolean',
    },
  ];

  const renderGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid...' />;
    } else {
      let filter = [];

      return (
        <Grid
          amount={20}
          columns={stockColumns}
          query={pageStockItems}
          queryName='pageStockItems'
          defaultSortField='requestId'
          globalFilters={gridFilter ? [gridFilter, ...filter] : [...filter]}
          refresh
        />
      );
    }
  };

  return (
    <Fragment>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={9}>
            {stockFilterButtons.map((item, index) => {
              return (
                <Button
                  key={index}
                  className='mt-3 mb-3 ml-2'
                  onClick={() => {
                    setGridFilter(item.filter);
                  }}>
                  {item.title}
                </Button>
              );
            })}
            <StockTotals />
            {nonBarcodeDeploy.length > 0 && (
              <Button variant='info' className='mt-3 mb-3 ml-2' onClick={handleDeploy}>
                Save Changes?
              </Button>
            )}
          </Col>
          <Col md={3}>
            <h3 className='mt-3 mb-3 mr-2 float-right'>Current OIT Stock</h3>
          </Col>
        </Row>
        <Row className='ml-2'>
          <span style={{ color: '#f00' }}>*&nbsp;</span>
          Only stock items that don't require a barcode can be deployed or put back in stock using these checkboxes.
          <br />
          All barcoded items will update automatically.
        </Row>
        <div className='ml-2 mr-2'>{renderGrid()}</div>
      </div>
    </Fragment>
  );
};
